import React from 'react'


import { createStyles } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

const styles = createStyles({
  stepper: {
    display: 'flex',
    marginBottom: '30px'
  },
  stepperItem: {
    display: 'inline-block',
    background: '#e0e0e0',
    marginRight: '3px',
    padding: '1px 15px',
    borderRadius: '3px',
    cursor: 'pointer',
    marginBottom: '3px'
  },
  active: {
    display: 'inline-block',
    background: 'blue',
    color: 'white',
    marginRight: '3px',
    padding: '1px 15px',
    borderRadius: '3px',
    cursor: 'pointer',
    marginBottom: '3px'
  },
  disabled: {
    display: 'inline-block',
    background: 'green',
    color: 'white',
    marginRight: '3px',
    padding: '1px 15px',
    borderRadius: '3px',
    cursor: 'pointer',
    marginBottom: '3px'
  },
  listBalls: {
    position: 'relative',
    height: '100%',
    listStyle: 'none',
    padding: '0',
    margin: '0',
    textAlign: 'center'
  },
  listBallsItem: {
    padding: '5px 0',
    fontSize: '13px',
    color: '#777'
  },
  listBallsTotal: {
    position: 'absolute',
    bottom: '0',
    width: '100%',
    fontSize: '13px',
    fontWeight: 'bold',
    color: '#000',
    textAlign: 'center'
  }
})

const getTotal = (list) => {
  const sum = list.reduce((a, b) => {
    const numberA = isNaN(a) ? 0 : a
    const numberB = isNaN(b) ? 0 : b
    return parseFloat(numberA) + parseFloat(numberB)
  })
  return sum.toFixed(2)
}

const ApplicantExamStepper = ({ classes, questionList, activeQuestionId, setActiveQuestion, setCurrentPosition, ballsResult }) => {
  return (
    <>
      <div className={classes.stepper}>
        {questionList && questionList.map((examQuestion, i) => (
            <div key={examQuestion.id}>
              {examQuestion.expertMark.isCreated ? (
                  <div
                      onClick={() => {
                        setActiveQuestion(examQuestion)
                        setCurrentPosition(i + 1)
                      }}
                      className={classes.disabled}>{i + 1}
                  </div>
              ) : (
                  <div onClick={() => {
                    setActiveQuestion(examQuestion)
                    setCurrentPosition(i + 1)
                  }} className={examQuestion.id === activeQuestionId ? classes.active : classes.stepperItem}>
                    {i + 1}
                  </div>
              )
              }
              <ul className={classes.listBalls}>
                {ballsResult[i] && ballsResult[i].map((item) => (
                    <li className={classes.listBallsItem}>
                      {isNaN(item) ? '0.00' : item.toFixed(2)}
                    </li>
                ))}
                <li className={classes.listBallsTotal}>
                  {ballsResult[i] && (
                      getTotal(ballsResult[i])
                  )}
                </li>
              </ul>
            </div>
        ))}
      </div>
    </>
  )
}

export default withStyles(styles)(ApplicantExamStepper)
